var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"allowed-dates":_vm.dateAllowed,"color":"primary","min":_vm.minDate},on:{"change":_vm.changeDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }